import React from 'react';

export default function OperatorLogo({ operator, size = "md" }) {
  const op = (operator || "").toLowerCase();

  const configs = {
    jio: { bg: "bg-blue-600 text-white ring-blue-100", label: "Jio" },
    airtel: { bg: "bg-red-600 text-white ring-red-100", label: "airtel" },
    vi: { bg: "bg-purple-700 text-white ring-purple-100", label: "Vi" },
    bsnl: { bg: "bg-emerald-600 text-white ring-emerald-100", label: "BSNL" },
  };

  const current = configs[op] || { bg: "bg-slate-800 text-white ring-slate-100", label: operator };
  const sizeClasses = size === "lg" ? "w-16 h-16 text-xl" : size === "sm" ? "w-8 h-8 text-xs" : "w-12 h-12 text-base";

  return (
    <div className={`${current.bg} ${sizeClasses} rounded-full flex items-center justify-center font-black shadow-sm ring-4 select-none`}>
      {current.label}
    </div>
  );
}